import {
	DocExamplePrompts,
	DocHeading,
	DocList,
	DocNextLink,
	DocPage,
	DocParagraph,
	DocSubheading,
	DocTerm,
} from "../DocElements";

const EXAMPLE_PROMPTS = [
	"アップロードした組立工程の動画を要素作業に分けて、作業ごとの所要時間を表にまとめてください",
	"この工程のピッキング動作をロボットに学習させたいです。必要なデータ量と収集計画を提案してください",
	"学習したモデルを評価データで評価して、成功率と失敗パターンをレポートにまとめてください",
];

export function ChatPage() {
	return (
		<DocPage title="チャット">
			<DocParagraph>
				Izanagiのエージェントとチャットして、さまざまな作業に取り組めます。エージェントはロボット向けの機械学習とソフトウェア開発のノウハウを持っているので、エンジニアではない方でも、タスクを説明するだけで工程解析からモデルの学習・評価までできます。
			</DocParagraph>

			<DocHeading>チャット・インタフェース</DocHeading>
			<DocSubheading>入力欄</DocSubheading>
			<DocParagraph>
				エージェントへの依頼を書いて送信します。入力欄の下から次の操作もできます。
			</DocParagraph>
			<DocList>
				<li>
					<DocTerm>確認モード</DocTerm>
					：「自動承認」ではエージェントが確認なしで作業を進め、「手動確認」では操作の前にあなたの承認を求めます。
				</li>
				<li>
					<DocTerm>モデル選択</DocTerm>
					：エージェントが使うAIモデルを選びます。
				</li>
				<li>
					<DocTerm>コンテキストメーター</DocTerm>
					：会話の長さが上限の何％に達したかを示します。
				</li>
				<li>
					<DocTerm>添付</DocTerm>
					：ファイルや画像をエージェントに渡します。チャット画面へのドラッグ＆ドロップでも添付できます。画像（PNG・JPEG・GIF・WebP）・PDF・テキストファイルはメッセージに直接入るので、エージェントがすぐに中身を読めます。それ以外の形式や大きすぎるファイル（PDFは10MB、テキストは1MBまで）、1回の送信で画像・文書それぞれ4件を超えた分は環境にアップロードされ、エージェントが必要に応じて開きます。アップロードされたファイルはファイルツリーで確認できます。
				</li>
			</DocList>

			<DocSubheading>ファイルツリー</DocSubheading>
			<DocParagraph>
				エージェントの環境にあるファイルを一覧できます。ファイルのアップロードもここからできます。チャットでファイル名を伝えれば、エージェントがそのファイルを読み込んで作業に使います。
			</DocParagraph>

			<DocSubheading>プレビューペイン</DocSubheading>
			<DocParagraph>
				ファイルツリーやチャットで開いたファイル（画像・動画・PDF・CSVなど）を表示します。
			</DocParagraph>

			<DocSubheading>チャット一覧</DocSubheading>
			<DocParagraph>
				選択中のエージェントのチャットだけが並びます。過去のチャットの検索や切り替えができます。
			</DocParagraph>

			<DocHeading>例文</DocHeading>
			<DocExamplePrompts prompts={EXAMPLE_PROMPTS} />
			<DocNextLink to="/docs/agents">エージェントを管理する</DocNextLink>
		</DocPage>
	);
}
